import React, { useState } from 'react';
import Pit from './Pit';

const Board = ({ pits, onPitClick, player1Name, player2Name }) => {
    const rows = [[12, 11, 10, 9, 8, 7], [0, 1, 2, 3, 4, 5]];
    const [currentPlayer, setCurrentPlayer] = useState(1);
    const [clickedPit, setClickedPit] = useState(null);

    const handlePitClick = (index) => {
        if (clickedPit === index) {
            onPitClick(index);
            setClickedPit(null);
            setCurrentPlayer(currentPlayer === 1 ? 2 : 1);
        } else {
            setClickedPit(index);
        }
    };

    const getHighlightedPits = (index) => {
        if (index === null) return [];
        const highlightedPits = [];
        let stonesToDistribute = pits[index];
        let nextPit = index;
        while (stonesToDistribute > 0) {
            nextPit = (nextPit + 1) % pits.length;
            highlightedPits.push(nextPit);
            stonesToDistribute--;
        }
        return highlightedPits;
    };

    const highlightedPits = getHighlightedPits(clickedPit);

    return (
        <div className="flex flex-col items-center justify-center lg:h-[450px] ls:h-[300px] sm:h-[250px] relative">
            <div className="papan flex items-center bg-cover rounded-full shadow-lg lg:w-[1200px] lg:px-6 lg:py-12 ls:px-3 ls:py-5 ls:w-11/12 sm:px-6 sm:py-3 sm:w-4/5">
            <div className="player-name-top absolute text-[#f3caaf] font-bold text-xl lg:top-10 bg-[#8f5732] lg:px-5 lg:py-1 rounded-full sm:top-11 sm:text-xs sm:px-2 sm:py-[2px]">
                {player2Name || 'PLAYER 2'}
            </div>
                <div className="flex justify-center items-center w-32 h-32 rounded-full text-white cursor-pointer relative transition-shadow duration-1000 ease-in-out">
                    <Pit
                        id="pit-13"
                        stones={pits[13]}
                        isHighlighted={highlightedPits.includes(13)}
                        currentPlayer={currentPlayer}
                        isClicked={clickedPit === 13}
                    />
                </div>

                <div className="flex flex-col">
                    {rows.map((row, rowIndex) => (
                        <div key={rowIndex} className="flex justify-center">
                            {row.map((pitIndex) => (
                                <Pit
                                    key={pitIndex}
                                    id={`pit-${pitIndex}`}
                                    stones={pits[pitIndex]}
                                    onClick={() => handlePitClick(pitIndex)}
                                    isHighlighted={highlightedPits.includes(pitIndex)}
                                    currentPlayer={currentPlayer}
                                    isClicked={clickedPit === pitIndex}
                                />
                            ))}
                        </div>
                    ))}
                </div>

                <div className="flex justify-center items-center w-32 h-32 rounded-full text-white cursor-pointer shadow-inner relative transition-shadow duration-1000 ease-in-out">
                    <Pit
                        id="pit-6"
                        stones={pits[6]}
                        isHighlighted={highlightedPits.includes(6)}
                        currentPlayer={currentPlayer}
                        isClicked={clickedPit === 6}
                    />
                </div>
            
            <div className="player-name-bottom absolute text-[#f3caaf] font-bold text-xl lg:bottom-10 bg-[#8f5732] lg:px-5 lg:py-1 rounded-full sm:bottom-11 sm:text-xs sm:px-2 sm:py-[2px]">
                {player1Name || 'PLAYER 1'}
            </div>
            </div>

        </div>
    );
};

export default Board;
